import type { ActionFunctionArgs } from '~/types/route-args';

import { passkeyLoginVerifyAction } from '~/modules/user/passkey/passkey.server';

export const PASSKEY_LOGIN_VERIFY_API_ROUTE =
    '/remix-api/user/passkey-login-verify';

export const action = (args: ActionFunctionArgs) =>
    passkeyLoginVerifyAction(args);

export type PasskeyLoginVerifyAction =
    | { ok: true; sessionEstablished: boolean }
    | { ok: false; message: string };
